import type {
  AgentContentBlock,
  AgentMessage,
  AgentToolResultBlock,
  AgentToolUseBlock,
} from "@calcplan/ai-capabilities";

/**
 * Anthropic exige que toda mensagem com tool_use seja seguida imediatamente
 * pelos tool_result correspondentes. A compactação e uma pausa para orientação
 * nunca podem deixar chamadas futuras da mesma rodada sem fechamento.
 */
export function ensureToolResultProtocol(messages: AgentMessage[]): AgentMessage[] {
  const normalized: AgentMessage[] = [];

  for (let index = 0; index < messages.length; index += 1) {
    const message = messages[index]!;
    if (message.role === "assistant") {
      const calls = message.content.filter((block): block is AgentToolUseBlock => block.type === "tool_use");
      normalized.push(message);
      if (!calls.length) continue;

      const possibleResultMessage = messages[index + 1];
      const resultMessage = possibleResultMessage?.role === "user" ? possibleResultMessage : null;
      const existingResults = new Map<string, AgentToolResultBlock>();
      const ordinaryContent: AgentContentBlock[] = [];
      for (const block of resultMessage?.content ?? []) {
        if (block.type === "tool_result") {
          if (!existingResults.has(block.toolUseId)) existingResults.set(block.toolUseId, block);
        } else {
          ordinaryContent.push(block);
        }
      }
      const results = calls.map((call) => existingResults.get(call.id) ?? interruptedToolResult(call));
      normalized.push({ role: "user", content: [...results, ...ordinaryContent] });
      if (resultMessage) index += 1;
      continue;
    }

    const ordinaryContent = message.content.filter((block) => block.type !== "tool_result");
    if (ordinaryContent.length) normalized.push({ ...message, content: ordinaryContent });
  }

  return normalized;
}

function interruptedToolResult(call: AgentToolUseBlock): AgentToolResultBlock {
  return {
    type: "tool_result",
    toolUseId: call.id,
    isError: true,
    result: {
      code: "INTERRUPTED_TOOL_CALL",
      error: "A rodada foi pausada antes desta chamada ser executada.",
      retryable: true,
      recovery: "Reavalie se esta chamada ainda é necessária depois da orientação recebida.",
    },
  };
}
